var option_default = {
  "option": "WZ2-v",
  "user_choice": "uhH4o",
  "check": "_9bwqd",
  "image": "Dsawz",
  "input": "Hnq4F",
  "title": "LEEgc",
  "centered": "ICMzK",
  "with_result": "cuFBo",
  "list": "hCqN0",
  "with_image": "UqP11",
  "progress": "DWUbf",
  "progress_value": "x64RI",
  "label": "ASG6q",
  "cta": "nE4PV",
  "adornment_icon": "_1OZBv",
  "remove": "bE2wr",
  "removeButton": "I-asK",
  "removeButtonIcon": "_43Req",
  "overlay": "Fh7Wk",
  "shown": "gHGHI",
  "dark": "fL25C",
  "spinner": "EHeEA",
  "spin": "e3DtM"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
